import { DatePipe } from '@angular/common';
import { Component, computed, inject, input, resource } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SimpleApi } from '@core/api/simple.api';
import { LetLoadingIndicatorComponent } from '@shared/let-loading-indicator/let-loading-indicator.component';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToolbarModule } from 'primeng/toolbar';
import { Konvertering } from '../konvertering.model';

@Component({
  selector: 'app-konvertering-detail',
  imports: [
    ToolbarModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    SplitButtonModule,
    InputTextModule,
    PanelModule,
    RouterLink,
    LetLoadingIndicatorComponent,
    DatePipe,
  ],
  templateUrl: './konvertering-detail.component.html',
  styleUrl: './konvertering-detail.component.css',
})
export class KonverteringDetailComponent {
  id = input.required<number>();
  simpleApi = inject(SimpleApi);

  data = resource({
    params: () => this.id(),
    loader: async ({ params, abortSignal }) => {
      return await this.simpleApi.getSingle<Konvertering>(
        `/api/admin/konvertering/${params}`,
        {},
        abortSignal
      );
    },
  });

  konvertering = computed(() => {
    const konvertering = this.data.value();
    return konvertering || ({} as Konvertering);
  });
}
